import {environment} from '../../../environments/environment';

export class Constants {

  // CONFIGURACION DE RUTAS - ENTORNO
  API_URL = environment.apiProtocol + environment.apiUrl + ':' + environment.apiPort;
  API_REST = this.API_URL + '/apiAvancer/';
  URL_VER_PDF = this.API_REST + 'PDF/';
  URL_DESCARGA_FICHERO = this.API_REST + 'file/';

  // COLUMNAS ESPECIALES
  ACCIONES = 'Acciones';
  EDITAR = 'Editar';
  DOMICILIOS = 'Domicilios';
  CONTACTOS = 'Contactos';
  DOCUMENTOS = 'Documentos';
  CLIENTES = 'Clientes';
  SOLICITUD = 'Solicitud';
  ACTUALIZAR_TABLA = 'ActualizarTabla';
  RESET_TABLA = 'Reset Tabla';
  AGREGAR = 'Agregar';
  VISUALIZAR = 'Visualizar';
  RELOJ = 'Pendiente Finalizar Proceso';
  ELIMINAR = 'Eliminar';
  ELIMINAR_DOCUMENTACION = 'Eliminar Documentacion';
  XML = 'XML';
  PDF = 'PDF';
  GENERAR_BUSQUEDA = 'Generar Busqueda'
  TIPO_CAMBIO = 'Tipo de Cambio';
  FUSIONAR = 'Fusionar';
  EMAIL = 'Enviar Email';
  NOTIFICADO = 'Notificado Email';
  NOTIFICADO_ANTICIPO = 'Notificado Anticipo';
  CUENTAS_BANCARIAS = 'Cuentas Bancarias';
  INMUEBLES = 'Inmuebles del Desarrollo Mobiliario';
  PROPIETARIOS = 'Propietarios';
  CONDICIONES = 'Condiciones Contratos';
  CONTRATOS = 'Contratos / Prorrogas';
  BUSCAR = 'Buscar';
  PPE = 'Personas Bloqueadas / PPE'
  RESET = 'Reset';
  CONVENIOS = 'Convenios';
  ARRENDADORES = 'Arrendadores';
  FACTURACION_CONDICIONES = 'Facturación Condiciones';
  UPLOAD_FACTURA = 'Cargar Facturas';
  VALIDAR = 'Validar Registro';
  REVISADO = 'Revisado';
  CANCELAR = 'Cancelar Registro';
  PAGADO = 'Pagado';
  NOTA_CREDITO = 'Con Nota Crédito';
  VENDIDO = 'Vendido';
  SUBDIVISION = 'Subdivision';
  FUSION = 'Fusión';
  PAGOS = 'Pagos';
  PAGOS_AMORTIZABLES = 'Pagos Amortizables';
  CUENTAS_CONTABILIDAD = 'Movimientos Contabilidad CONTPAQi';
  REQUISICION = 'Requisición Relacionada';
  VALIDAR_CFDI = 'Validar CFDI SAT';
  CANCELAR_CFDI = 'Cancelar CFDI';
  TERCEROS = 'Terceros';
  DESCARGAR = 'Descargar';
  NOTAS = 'Notas';
  HISTORIAL_PAGOS = 'Historial de Pagos';
  CUENTAS_CONTABLES = 'Cuentas Contables CONTPAQi';
  INFORMACION_GENERAL = 'Información General';
  FORMATO_IDENTIFICACION = 'Formato de Identificación';
  CONSTANCIA = 'Constancia';
  DESCARGAR_ADJUNTOS = 'Descargar Adjuntos';
  ODC = 'Orden de Compra';
  ASISTENTE = 'Asistente';
  MAPA = 'Mapa';
  REGRESAR = 'Regresar';
  DETALLES = 'Detalles';
  EMPRESAS = 'Empresas';
  PERMISOS = 'Permisos';
  RESET_PASSWORD = 'Resetear Contraseña';

  // FORMATO COLUMNAS
  TEXT = 'text';
  CURRENCY = 'currency';
  DATE = 'date';
  CONTROL = 'control';
  DATETIME = 'datetime';
  NUMBER = 'number';
  CHECK = 'check';
  CONICONOPOP = 'icono con POP';
  SEMAFORO = 'semaforo';
  PORCENTAJE = 'porcentaje';
  // FORMATO FOOTER
  SUMA = 'suma';
  MAXIMO = 'maximo';
  MINIMO = 'minimo';
  VACIO = 'vacio';
  TITULOTOTALES = 'totales';
  INTEGER = 'integer';
  STRING = 'string';

  // TIPO DE PERSONAS
  PERSONA_FISICA = 1;
  PERSONA_MORAL = 2;

  // TABLAS
  INPATRIM = 'inpatrim';
  PSCONTAC = 'pscontac';
  PSDOMICI = 'psdomici';
  PSCTABAN = 'psctaban';
  PVCTABAN = 'pvctaban';
  PVCONTAC = 'pvcontac';
  RFFACTUR = 'rffactur';
  EMMOVIMI = 'emmovimi';
  PSPERSON = 'psperson';
  INPATINM = 'inpatinm';
  INPATPRO = 'inpatpro';
  GLTCD = 'gltcd';
  PREPAGOS = 'prepagos';
  CTCONPER = 'ctconper';
  CTCONTRA = 'ctcontra';
  CTCONVEN = 'ctconven';
  INSEGURO = 'inseguro';
  INSEGURO_AMORIZACIONES = 'inseguro_amortizaciones';
  INSEGURO_PAGOS = 'inseguro_pagos';
  LILICENC = 'lilicenc';
  PVPROVEE = 'pvprovee';
  CTCONDIC = 'ctcondic';
  RQGENRAL = 'rqgenral';
  CPFACTUR = 'cpfactur';
  CPMOVIMI = 'cpmovimi';
  PSCTACON = 'psctacon';
  PSTERCER = 'pstercer';
  CFDIS = 'cfdis';
  PSCLICON = 'psclicon';
  PVCTACON = 'pvctacon';
  UVPERMIS = 'uvpermis';
  PSINFGEN = 'psinfgen';
  CGGASTOS = 'cggastos';
  CGGASDET = 'cggasdet';
  CTCONFAC = 'ctconfac';
  LEACUSES = 'leacuses';
  SAFORPAG = 'saforpag';
  SAMETPAG = 'sametpag';
  GLTIPMON = 'gltipmon';
  SAUSOCFD = 'sausocfd';
  SAUNIMED = 'saunimed';
  SAPROSER = 'saproser';
  GLBANCOS = 'glbancos';
  GLASENTA = 'glasenta';
  GLASEGUR = 'glasegur';
  GLNACION = 'glnacion';
  USUSUARI = 'ususuari';

  // Especiales
  PSPERSON_PROPIETARIO = 'psperson-propietarios';
  ESTADO_CUENTA_CXC = 'estadoCuentaCXC';
  ANTIGUEDAD_SALDO = 'antiguedadSaldosCXC';

  // Filtros
  SEARCH_PAGOS_CXC = 'search-pagos-cxc';
  SEARCH_FACTURACION_CXC = 'search-facturacion-cxc';
  SEARCH_ESTADO_CUENTA_CXC = 'search-estado-cuenta-cxc';
  SEARCH_ANTIGUEDAD_CXC = 'search-antiguedad-cxc';
  SEARCH_FACTURACION_CXP = 'search-facturacion-cxp';
  SEARCH_PAGOS_CXP = 'search-pagos-cxp';
  SEARCH_PERSONAS_CLIENTES = 'search-personas-clientes';
  SEARCH_INVENTARIO_PROPIEDADES = 'search-inventario-propiedades';
  SEARCH_REQUISICIONES = 'search-requisicion';
  SEARCH_PREDIALES = 'search-prediales';
  SEARCH_SEGUROS = 'search-seguros';
  SEARCH_COMPROBACION_GASTOS = 'search_comprobacion_gastos';
  SEARCH_GRAFICO_CXC_FACTURACION = 'search-grafico-cxc-facturacion';
  SEARCH_GRAFICO_CXC_PAGOS = 'search-grafico-cxc-pagos';
  SEARCH_GRAFICO_CXC_CONSUMO_TIMBRADO = 'search_grafico_cxc_consumo_timbrado';
  SEARCH_GRAFICO_CXP_REQUISICIONES_BY_DEPTO = 'search_grafico_requisiciones_by_depto';
  SEARCH_GRAFICO_TIPO_CAMBIO_DIARIO_MENSUAL = 'search-grafico-tipo-cambio-mensual';
  SEARCH_GRAFICO_CXP_PAGOS = 'search-grafico-cxp-pagos';
  SEARCH_GRAFICO_CXC_METODOS_PAGO = 'search-grafico-cxc-metodos-pago';
  SEARCH_GRAFICO_CXC_USO_CFDI = 'search-grafico-cxc-uso-cfdi';
  SEARCH_GRAFICO_CXC_FORMAS_PAGO = 'search-grafico-cxc-formas-pago';
  SEARCH_ACUSES_PLD = 'search-acuses-pld';
  TEMA_USUARIO = 'tema-usuario';

  // Usuarios Especiales
  USUARIOS_ESPECIALES = [520];

  // PROCESOS
  EMPRESAS_FILTRO_PROCESOS = [1, 4];
  EMPRESAS_FILTRO_ACUSES_PLD = [1, 11, 98, 114, 2, 37];

  // Graficos
  GRAFICO_CXC_FACTURACION = 'Grafico CxC Facturación';
  GRAFICO_CXC_PAGOS = 'Grafico CxC Pagos';
  GRAFICO_CONSUMO_MENSUAL_TIMBRADO = 'Grafico Consumo Mensual Timbrado';
  GRAFICO_REQUIISICIONES_BY_DEPTO = 'Gráfico Requisiciones Por Departamento';
  GRAFICO_TIPO_CAMBIO_DIARIO_MENSUAL = 'Gráfico Tipo Cambio Diario Mensual';
  GRAFICO_CXP_PAGOS = 'Grafico CxP Pagos';
  GRAFICO_CXC_METODOS_PAGO = 'Grafico Metodos Pago CXC';
  GRAFICO_CXC_USO_CFDI = 'Grafico Uso CFDI CXC';
  GRAFICO_CXC_FORMAS_PAGO = 'Grafico Formas Pago CXC';

  // RUTAS SFTP

  SFTP_CPFACTUR = 'com.avancer.cxp.facturacion';
  SFTP_LEACUSES = 'com.avancer.legal.acuses';
  SFTP_PSPERSON = 'com.avancer.personas.adjuntos';
  SFTP_INPATRIM = 'com.avancer.patrimonios.adjuntos';
  SFTP_INPATINM = 'com.avancer.inmuebles.adjuntos';
  SFTP_PREPAGOS = 'com.avancer.prediales.adjuntos';
  SFTP_CTCONTRA = 'com.avancer.contratos.adjuntos';
  SFTP_CTCONVEN = 'com.avancer.convenios.adjuntos';
  SFTP_INSEGURO = 'com.avancer.seguros.adjuntos';
  SFTP_LILICENC = 'com.avancer.licencias.adjuntos';
  SFTP_RQGENRAL = 'com.avancer.requisiciones.adjuntos';
  SFTP_CPMOVIMI = 'com.avancer.cxp.adjuntos';
  SFTP_CGGASDET = 'com.avancer.comprobaciongastos.adjuntos';

  // EXTENSION FICHEROS
  EXTENSION_PDF = 'pdf';
  EXTENSION_XML = 'xml';

}
